const contact = {
  id: 'Groupe',
};

export default contact;
